import $ from 'jquery';
import Api from '../utilities/Api';
import Popup from '../utilities/Popup';

$('body').on('click', '.accordion--order .accordion-title', function () {
    $(this).parents('.accordion--order').toggleClass('accordion--opened');
});

$('.js-personal-order-items').click(function (e) {
    e.preventDefault();

    const orderId = $(this).attr('data-order-id');
    const orderProducts = JSON.parse($(this).attr('data-order-products'));
    const rows = orderProducts.map(({ itemname, price, cnt }) => {
        return `
            <tr class="products-table-item">
                <td data-label="Товар">
                    <div class="products-table-item__info">
                        <a href="/catalog/zdorove/ad-balans-60-kaps" target="_blank" class="products-table-item__name">
                            ${itemname}
                        </a>
                    </div>
                </td>
                <td data-label="Количество, шт">
                    ${cnt}
                </td>
                <td data-label="Стоимость, ₽">
                    <div class="products-table-item__price">
                       ${price}
                    </div>
                </td>
                <td data-label="Сумма, ₽">
                    <div class="products-table-item__price-total">
                        ${price * cnt}
                    </div>
                </td>
            </tr>
        `;
    }).join('');
    let table = `
        <table class="products-table">
            <thead>
                <tr>
                    <th>
                        <span>Товар</span>
                    </th>
                    <th>
                        <span>Количество, шт</span>
                    </th>
                    <th>
                        <span>Стоимость, ₽</span>
                    </th>
                    <th>
                        <span>Сумма, ₽</span>
                    </th>
                </tr>
            </thead>
            <tbody>
                ${rows}
            </tbody>
        </table>
    `;
    Popup.showContent(`Состав заказа №${orderId}`, table, 1200);
});

$('.js-personal-order-cancel').click(function (e) {
    e.preventDefault();

    if (window.confirm('Вы точно хотите отменить заказ?')) {
        const orderId = $(this).parents('.accordion--order').attr('data-order-id');
        $(this).addClass('disabled');

        Api.post('/api/v2/order/cancel/', { order_id: orderId })
            .then((response) => {
                if (response.isError) {
                    Popup.notify(response.error);
                    $(this).removeClass('disabled');
                } else {
                    if (response.message) {
                        Popup.notify(response.message);
                    }
                    setTimeout(() => {
                        window.location.reload();
                    }, 1200);
                }
            });
    }
});
